module.exports = "https://cdn.realtymogul.com/static/media/icon_navigate.c5101512.svg";